import { useAuth0 } from '@auth0/auth0-react';
import { Avatar } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import FamilyRestroomIcon from '@mui/icons-material/FamilyRestroom';
import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';
import BreadCrumbs from 'components/Breadcrumbs';
import AlertDialog from 'components/Dialog';
import MyButton from 'components/MyButton';
import AuthService from 'Lib/API/Auth';
import React, { useEffect, useState } from 'react';
import { toastr } from 'react-redux-toastr';
import { useHistory } from 'react-router-dom';
import edit_tag from '../../../assets/icons/edit_tag.svg';
import lineTags from '../../../assets/icons/lineTags.svg';
import plus_addTag from '../../../assets/icons/plus_addTag.svg';
import ProfileCompletion from '../MembersDrawer/ProfileCompletion';
import AddNewTag from './AddNewTag';
import './style.scss';
import { fontConfig } from "theme/fontConfig";

const DetailsHeader = ({ account, setRefresh, refresh }) => {
  const accountTags = account?.tags ? [...account?.tags] : []
  const [openTag, setOpenTag] = useState(false);
  const [openEditTag, setOpenEditTag] = useState(false);
  const [selectedTag, setSelectedTag] = useState(accountTags);
  const [deleteTagConfirm, setDeleteTagConfirm] = useState(false);
  const [tagToDelete, setTagToDelete] = useState(null);
  const history = useHistory();
  const { getAccessTokenSilently } = useAuth0();
  const links = [
    <Link
      key="1"
      color="#666667"
      onClick={() => history.push('/members')}
      fontSize={14}
      underline="hover"
    >
      Members
    </Link>,
    <Typography key="2" color="rgba(102, 102, 103, 0.6)" fontSize={14}>
      {account?.family_name}
    </Typography>,
  ];

  useEffect(() => {
    // console.log(account, "accountaccount")

    // if (account) {
    //   // setSelectedTag([...account?.tags]);
    //   const {
    //     account_id,
    //     admin_name,
    //     appear_in_member_directory,
    //     archived,
    //     createdAt,
    //     created_by,
    //     deceases,
    //     family_members,
    //     relationship,
    //     _id,
    //     family_name,
    //     main_contact,
    //     organization,
    //     profile_img,
    //     status,
    //     updatedAt,
    //     primary_email_address,
    //     primary_phone_number,
    //     __v,
    //     ...data
    //   } = { ...(account ? account : {}) };
    //   const insertedValues = Object.values(data);
    //   const insertedValuesLng = insertedValues.filter((field) => {
    //     if (field !== '') {
    //       if (typeof field === 'object') {
    //         if (
    //           field?.formattedAddress !== undefined ||
    //           field?.product_id !== undefined
    //         ) {
    //           return true;
    //         } else return false;
    //       }
    //       return true;
    //     } else return false;
    //   }).length;
    //   setAccountComplition(
    //     Math.round(((insertedValuesLng + 6) / 12) * 100) > 100
    //       ? 100
    //       : Math.round(((insertedValuesLng + 6) / 12) * 100)
    //   );
    // }


  }, []);

  const deleteTag = async (tag) => {
    const token = await getAccessTokenSilently();
    AuthService.deleteAccountTag({ accountId: account?._id, tag }, token)
      .then((res) => {
        setSelectedTag(selectedTag.filter((item) => item !== tag));
        setRefresh(!refresh);
      })
      .catch((err) => {
        console.log('err: ', err);
        toastr.error('Error', err?.data?.message || 'Something went wrong');
      });
  };

  return (
    <div className="details-header">
      <div className="navigator">
        <BreadCrumbs links={links} />
      </div>
      <div className="header-content">
        <div className="left-side">
          <div className="lef-content">
            <div className="avatar">
              <Avatar
                alt={'account'}
                style={{ marginRight: '10px', height: '50px', width: '50px' }}
              >
                <FamilyRestroomIcon fontSize="large" />
              </Avatar>
            </div>
            <div className="details">
              <div className="name">{account?.family_name}</div>
              <div className="account-id py-2">#{account?.account_id}</div>
              <div className="account-types">
                {account?.payment?.account_type && (
                  <div className="account-type px-3 text-capitalize">
                    {account?.payment?.account_type}
                  </div>
                )}
                {account?.payment?.account_sub_type?.title && (
                  <div className="sub-type mx-2 px-3">
                    {account?.payment?.account_sub_type?.title}
                  </div>
                )}
                {account?.payment?.product_id && (
                  <div className="billing-type px-3">
                    {account?.payment?.product_id?.prod_name}
                  </div>
                )}
                {selectedTag?.length > 0 ? (
                  <div className="tags">
                    {selectedTag?.sort((a, b) => a?.toLowerCase().localeCompare(b?.toLowerCase())).map((tag, i) => {
                      return (
                        <span className="tag" key={i}>
                          {tag}
                          <span
                            style={{
                              marginLeft: '5px',
                              fontSize: '12px',
                              fontWeight: '400',
                              cursor: 'pointer',
                            }}
                            onClick={() => {
                              setTagToDelete(tag);
                              setDeleteTagConfirm(true);
                            }}
                          >
                            x
                          </span>
                        </span>
                      );
                    })}
                    <div className="add_tag">
                      <span
                        style={{
                          color: '#2555EF',
                          fontFamily: fontConfig.MemberDetailsAccountDetailsHeaderTextFont.family,
                          fontWeight: '500',
                          fontSize: '13px',
                          textAlign: 'center',
                          cursor: 'pointer',
                        }}
                        onClick={() => setOpenTag(true)}
                      >
                        +
                      </span>
                    </div>
                  </div>
                ) : (
                  <span
                    style={{
                      color: '#2555EF',
                      fontFamily: fontConfig.MemberDetailsAccountDetailsHeaderTextFont.family,
                      fontWeight: '500',
                      fontSize: '13px',
                      textAlign: 'center',
                      cursor: 'pointer',
                      marginLeft: "10px"
                    }}
                    onClick={() => setOpenTag(true)}
                  >
                    +
                  </span>
                )}
              </div>
            </div>
          </div>
        </div>
        {/* <div className="right-side">
          <ProfileCompletion profile={accountCompletion} title={'Account'} />
          <div className="message">
            <MyButton disabled={true} content="Message me" />
          </div>
        </div> */}
      </div>
      <div className="tag_modal">
        <Dialog
          open={openTag || openEditTag}
          onClose={() => {
            setOpenTag(false);
            setRefresh(!refresh);
          }}
          PaperProps={{
            style: {
              background: "#fff",
              borderRadius: "10px",
            },
          }}
        >
          <AddNewTag
            setOpenTag={setOpenTag}
            openTag={openTag}
            setOpenEditTag={setOpenEditTag}
            openEditTag={openEditTag}
            account={account}
            setRefresh={setRefresh}
            refresh={refresh}
          />
        </Dialog>
        <AlertDialog
          open={deleteTagConfirm}
          onDecline={() => {
            setDeleteTagConfirm(false);
          }}
          onAccept={() => {
            deleteTag(tagToDelete);
            setDeleteTagConfirm(false);
          }}
          title={`Are you sure?`}
          description={`Do you want to delete this tag?`}
        />
      </div>
    </div>
  );
};
export default DetailsHeader;
